import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest
} from "@angular/common/http";
import { inject } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { REQUIRE_CAPTCHA } from "./captcha.context";
import { TurnstileService } from "../services/turnstile.service";

/**
 * Interceptor HTTP que añade automáticamente el header X-Captcha-Front
 * solo a peticiones marcadas explícitamente con REQUIRE_CAPTCHA.
 */
export const captchaInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const turnstileService = inject(TurnstileService);
    const shouldAttachCaptcha = request.context.get(REQUIRE_CAPTCHA);

    if (!shouldAttachCaptcha) {
        return next(request);
    }

    const token = turnstileService.getToken();

    if (!token) {
        return throwError(() => new HttpErrorResponse({
            status: 400,
            statusText: 'Captcha Required',
            error: { message: 'Captcha requerido' },
        }));
    }

    const requestWithCaptcha = request.clone({
        setHeaders: {
            'X-Captcha-Front': token
        }
    });

    return next(requestWithCaptcha).pipe(
        catchError((error) => {
            turnstileService.requestTokenRefresh();
            return throwError(() => error);
        })
    );
};
